import { Component, Input } from '@angular/core';
import { IconPath } from '@app/shared/common/icons';
import { ButtonSizes, ButtonTypes } from '@models/app/types/Button';
import { ButtonLoaderComponent } from '../../loaders/button-loader/button-loader.component';
import { IconComponent } from '../../icon/icon.component';

import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'app-circle-button',
    templateUrl: './circle-button.component.html',
    styleUrls: ['./circle-button.component.scss'],
    standalone: true,
    imports: [ButtonComponent, IconComponent, ButtonLoaderComponent]
})
export class CircleButtonComponent {
  height = 'h-5'; // default is medium
  width = 'w-5'; // default is medium

  private sizeValue: ButtonSizes = 'small';

  // small || medium || large
  @Input() set size(content: ButtonSizes) {
    this.sizeValue = content;
    switch (content) {
      case 'small':
        this.height = 'h-3';
        this.width = 'w-3';
        break;
      case 'large':
        this.height = 'h-10';
        this.width = 'w-10';
        break;
    }
  }

  get size(): ButtonSizes {
    return this.sizeValue;
  }

  @Input() icon: IconPath = null;
  @Input() buttonType: ButtonTypes = 'none';
  @Input() class: string = null;

  loadingValue = false;

  @Input() set loading(content: boolean) {
    this.loadingValue = content;
  }
}
